exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.project-nav-link{color:#3b3b3b\n}\n.project-nav-link:hover{color:#007fb1\n}\n.project-nav-link-manager{background-color:#ffd966\n}", ""]);

// exports
